module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAAYFBMVEUAAAB4eHh5eXl6enp4eHh4eHh4eHh0dHR3d3d/f394eHh5eXl4eHh4eHh3d3d3d3d3d3d4eHh5eXl/f394eHh2dnZ3d3d4eHh3d3d2dnZ4eHh4eHh3d3d3d3d4eHh4eHj8KtjhAAAAH3RSTlMASFAwcOevGPcIz4+f79eAYL8oEN84QGi3WIfHeJenTxJErQAAANNJREFUeNrVkjUCxDAQA8PMzPr/Ly+Mu3Z9KhMVY+0o3xiKPLajy0sGfHmpgOPKOhoAKZWFHp4MG45tohSXOljKgEnYcU2oiu04tqjUIlq5BlEpXV9WoVD46HByZY4HjS/5CPbVLR47xHa33AGLXp8zjui4kofkhDOZA5YIzz89WroU3CRJkDK2IbtPr9O2NY81SPeix4LZCviO+npQg5qyLX4p6pG2KY8Q7sWwPl8CyrZHCPc0RASlQdj2ytu9DE5OLPdEUM2AukGYvDApCV3lv/MDVpQL8Z2MjRAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/paramIcon/∧.png
// module id = H4AP
// module chunks = 2